import CategoriesWithProducts from '@/features/pos/components/ProductCatalog/parts/CategoriesWithProducts'
import { Provider } from '@/features/pos/components/ProductConfigurationModal/contexts/Portal'
import { useConfigurableContainerModal } from '@/features/pos/hooks/configurable-container-modal/useConfigurableContainerModal'
import { useConfigurableProductModal } from '@/features/pos/hooks/configurable-product-modal/useConfigurableProductModal'
import { useHideSearchOnProductSelect } from '@/features/pos/hooks/search-product/useHideSearchOnProductSelect'
import { FC } from 'react'

interface ProductCatalogType extends FC {
    ProductConfigurationModalPortal: typeof Provider
}

const ProductCatalog: ProductCatalogType = () => {
    useConfigurableProductModal()
    useConfigurableContainerModal()
    useHideSearchOnProductSelect()

    return <CategoriesWithProducts />
}

ProductCatalog.ProductConfigurationModalPortal = Provider

export default ProductCatalog
